import { z } from "zod";
import { email, pageQuery, phone, trimmed } from "./common";

/**
 * Заявки на подключение с лендинга Coca (корень сайта платформы): анонимная форма → очередь «Заявки» в Platform Admin.
 * new — пришла; contacted — связались; demo — показали систему; won — подключили; lost — отказ.
 */
export const LEAD_STATUSES = ["new", "contacted", "demo", "won", "lost"] as const;
export type LeadStatus = (typeof LEAD_STATUSES)[number];
export const LEAD_FORMATS = ["cafe", "restaurant", "coffee", "fastfood", "bar", "bakery", "other"] as const;
export type LeadFormat = (typeof LEAD_FORMATS)[number];
export const LEAD_FORMAT_LABELS: Record<LeadFormat, string> = { cafe: "Кафе", restaurant: "Ресторан", coffee: "Кофейня", fastfood: "Фастфуд", bar: "Бар", bakery: "Пекарня", other: "Другое" };
export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = { new: "Новая", contacted: "Связались", demo: "Показали систему", won: "Подключили", lost: "Отказ" };

const blankToUndefined = (v: unknown) => (typeof v === "string" && v.trim() === "" ? undefined : v);

export const leadCreateSchema = z.strictObject({
  name: trimmed(2, 80),
  phone,
  email: z.preprocess(blankToUndefined, email.optional()),
  venueName: trimmed(2, 120),
  city: z.preprocess(blankToUndefined, trimmed(2, 80).optional()),
  format: z.enum(LEAD_FORMATS),
  branches: z.number().int().min(1).max(500).default(1),
  message: z.preprocess(blankToUndefined, trimmed(1, 1000).optional()),
  /** Откуда пришла заявка (utm_source / раздел лендинга) */
  source: z.preprocess(blankToUndefined, z.string().trim().max(64).optional()),
  /** Ловушка для ботов: люди это поле не видят и не заполняют */
  website: z.string().max(200).optional(),
});
export type LeadCreateInput = z.input<typeof leadCreateSchema>;

export const leadUpdateSchema = z.strictObject({
  status: z.enum(LEAD_STATUSES).optional(),
  note: z.preprocess(blankToUndefined, z.string().trim().max(2000).nullable().optional()),
});
export const platformLeadsQuery = pageQuery.extend({ status: z.enum(LEAD_STATUSES).optional() });
